import React from 'react'

const Circle = props => (
  <svg
    fill="transparent"
    viewBox="0 0 50 50"
    className={`CircleIcon ${props.className || ''}`}
  >
    <circle strokeWidth={4} cx={25} cy={25} r={21} />
  </svg>
)

export default Circle



// WEBPACK FOOTER //
// ./src/components/svgs/circle/index.js